export default {
  loadingProfile: "Profil wird geladen...",
  errorLoadingProfile: "Fehler beim Laden des Profils",
  profileChangedTo: "Profil geändert zu {{type}}",
  sectionSaved: "Abschnitt erfolgreich gespeichert",
  saveSection: "Abschnitt speichern",
  revertSection: "Zurücksetzen",
  checkHighlighted: "Bitte prüfen Sie die hervorgehobenen Felder",
  pageTitle: "Einstellungen",
  sectionsNav: "Abschnitte",
  profileDescription: "Verwalten Sie Profil, Kontakt- und Zahlungsdaten",
  confirmChangeTitle: "Profiltyp ändern?",
  confirmChangeMessage:
    'Der Wechsel von „{{from}}" zu „{{to}}" löscht die {{dataType}}-spezifischen Felder (Name, Geburtsdaten oder Firmendaten). Adresse, Kontakt, Ausweisdokument und Zahlungsdaten bleiben erhalten.',
  individual: "Privatperson",
  company: "Unternehmen",
  confirmChange: "Ja, Typ ändern",
  adminPageTitle: "Einstellungen",
  adminPageDescription: "Verwalten Sie Ihr Konto",
  adminCardTitle: "Staff-Profil",
  adminBadge: "Staff",
  taxValidation: {
    vatNotFound: "USt-IdNr. im Register nicht gefunden.",
    vatMatched: "{{name}} · {{address}}",
    fiscalCodeInvalid: "Ungültige Steuer-ID.",
  },
  forms: {
    region: {
      cardTitle: "Zahlungsregion",
      hint: "Bei Kontoerstellung zugewiesen und nicht änderbar.",
    },
    profileType: {
      cardTitle: "Profiltyp",
      individualTitle: "Privatperson",
      individualDesc: "Privater Bürger",
      businessTitle: "Unternehmen",
      businessDesc: "Firma oder Betrieb",
    },
    profileStatus: {
      completeTitle: "Profil vollständig",
      incompleteTitle: "Profil unvollständig",
      incompleteDesc:
        "Bitte füllen Sie alle Pflichtfelder aus, um Ihr Konto zu aktivieren",
    },
    person: {
      cardPersonal: "Persönliche Angaben",
      firstName: "Vorname",
      lastName: "Nachname",
      birthDate: "Geburtsdatum",
      birthPlace: "Geburtsort",
      birthPlacePh: "Stadt, Land",
      idAsShown: "Wie im Ausweis angegeben",
      fiscalCode: "Steuer-ID / SSN",
      fiscalCodePh: "Ihre Steueridentifikationsnummer",
      cardResidence: "Wohnadresse",
      cardIdentity: "Ausweisdokument",
    },
    company: {
      cardBusiness: "Unternehmensangaben",
      companyName: "Firmenname",
      companyNamePh: "Acme Corporation GmbH",
      vatNumber: "USt-IdNr.",
      vatNumberPh: "DE123456789",
      taxId: "Steuernummer des Unternehmens",
      taxIdPh: "Steueridentifikationsnummer des Unternehmens",
      cardRegistered: "Firmensitz",
      cardLegalRep: "Gesetzlicher Vertreter",
      fullName: "Vollständiger Name",
      fullNamePh: "Max Mustermann",
    },
    address: {
      street: "Straße und Hausnummer",
      streetPh: "Hauptstraße 123",
      postalCode: "Postleitzahl",
      postalPh: "12345",
      city: "Stadt",
      cityPh: "Berlin",
      state: "Bundesland/Region",
      statePh: "BE",
      country: "Land",
      countryPh: "Deutschland",
    },
    document: {
      type: "Dokumenttyp",
      typePh: "Personalausweis, Reisepass...",
      number: "Nummer",
      numberPh: "AB1234567",
      issuer: "Ausstellende Behörde",
      issuerPh: "Behörde",
      issueDate: "Ausstellungsdatum",
      expiryDate: "Ablaufdatum",
    },
    contact: {
      cardTitle: "Kontaktinformationen",
      phone: "Telefonnummer",
      phonePlaceholder: "+49 612 345 678",
      phoneHint:
        "Geben Sie die internationale Vorwahl ein (z. B. +49) oder wählen Sie ein Land; die Flagge aktualisiert sich automatisch.",
      email: "E-Mail",
      emailPh: "email@beispiel.de",
      emailHint:
        "Nach dem Speichern mit dem Link in unserer E-Mail bestätigen — kein Code nötig.",
      pec: "Zertifizierte E-Mail (PEC)",
      pecPh: "name@pec.com",
      pecHint: "Für elektronische Rechnungsstellung",
      verified: "Verifiziert",
      resendCode: "Code erneut senden",
      resendLink: "Link erneut senden",
      verifySaveFirst: "Änderungen speichern, dann bestätigen.",
      confirmCode: "Bestätigen",
      sendSmsCode: "SMS-Code senden",
      sendEmailLink: "Bestätigungs-E-Mail senden",
      enterSmsCode: "Geben Sie den 6-stelligen Code ein, den wir per SMS geschickt haben.",
      otpAriaLabel: "SMS-Bestätigungscode",
      verifyPhoneSent: "SMS gesendet — Code unten eingeben.",
      verifyEmailSent:
        "Wir haben einen Bestätigungslink gesendet. Öffnen Sie die E-Mail und klicken Sie darauf (auch vom Handy) — kein Code nötig. Diese Seite aktualisiert sich automatisch.",
      verifyEmailWaiting:
        "Warten auf den Klick auf den Link in Ihrer E-Mail…",
      verifyPhoneSuccess: "Telefon bestätigt.",
      verifyEmailSuccess: "E-Mail bestätigt.",
      verifyPhoneLimit: "SMS-Limit erreicht. Später erneut versuchen.",
      verifyEmailLimit: "E-Mail-Limit erreicht. Später erneut versuchen.",
      verifyConfirmLimit: "Zu viele Versuche. Später erneut versuchen.",
      verifyPhoneNotSmsCapable: "Diese Nummer kann keine SMS empfangen.",
      verifyCodeInvalid: "Ungültiger oder abgelaufener Code.",
      notificationChannel: "Buchungsbenachrichtigungen",
      notificationChannelHint:
        "Wählen Sie, wo Sie Benachrichtigungen über neue Buchungen, Nachrichten und Stornierungen erhalten.",
      notificationChannelWhatsApp: "WhatsApp",
      notificationChannelEmail: "E-Mail",
      notificationLanguage: "Benachrichtigungssprache",
    },
    payment: {
      cardTitle: "Zahlungsinformationen",
      iban: "IBAN",
      ibanOptional: "IBAN",
      ibanPh: "DE00 0000 0000 0000 0000 00",
      ibanHint: "15–34 Zeichen",
      accountHolder: "Kontoinhaber",
      accountHolderOptional: "Kontoinhaber",
      accountHolderPh: "Max Mustermann oder Acme GmbH",
      accountHolderHint: "Mindestens 3 Zeichen",
    },
  },
} as const;
